module.exports = {
    "baseUrl": "https://api-v4.primrose.health",
    "systemName": "System Prod",
    "companyTitle": "Review | Trillium Health",
    "metaTitle": "Review | Trillium Health",
    "favicon": "%PUBLIC_URL%/favicon.png",
    "redirectUrl": "https://tensaw.health/",
    "companyName": "Trillium Technologies",
    "copyRight": "Primrose Health and Trillium Technologies are trademarks of their respective owners.",
    "companyKey": "trillium",
    "cdnUrl": "https://cdn.primrose.health"
}